import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { GridCellParams } from '@mui/x-data-grid';
import { WhiteTooltip } from '@AMIEWEB/Common';
import { isInValidHours } from '../helper';
import { isNumber } from '../../../ModificationsUtils';

const StyledTootltip = makeStyles()((theme: Theme) => ({
  arrow: {
    '&:before': {
      border: '1px solid #E3DFDF',
    },
    color: theme.palette.components.tooltip.arrowColor,
  },
  truncation: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tooltipContent: {
    backgroundColor: theme.palette.components.tooltip.backgroundColor,
    border: '1px solid #E3DFDF',
    color: theme.palette.system.errorRed,
    fontWeight: 'normal',
  },
}));

export const CustomTooltipCellRenderer = React.memo(function CustomTooltipCellRenderer(cellParams: any) {
  const { classes } = StyledTootltip();

  const getTitle = props => {
    return isInValidHours(props) ? 'Required' : '';
  };

  return (
    <WhiteTooltip
      arrow={true}
      title={getTitle(cellParams)}
      classes={{ tooltip: classes.tooltipContent, arrow: classes.arrow }}
    >
      <span style={!cellParams?.row?.hours ? { paddingLeft: '40px' } : null} className={classes.truncation}>
        {isNumber(cellParams?.row?.hours) ? cellParams?.row?.hours : '--'}
      </span>
    </WhiteTooltip>
  );
});

export const ErrorTootlTipHour = (params: GridCellParams) => {
  return <CustomTooltipCellRenderer {...params} />;
};
